/* filepath: d:\gym-web-frontend\src\pages\BrowseSocieties\index.js */
import React from 'react';
import SocietiesList from '../../Societies/SocietiesList';

const BrowseSocieties = () => {
  return (
    <div className="browse-societies-page">
      <SocietiesList />
    </div>
  );
};

export default BrowseSocieties;